import alphabetA from "./images/A.svg";
import alphabetB from "./images/B.svg";
import alphabetC from "./images/C.svg";
import alphabetD from "./images/D.svg";
import alphabetE from "./images/E.svg";
import alphabetF from "./images/F.svg";
import alphabetG from "./images/G.svg";
import alphabetH from "./images/H.svg";
import alphabetI from "./images/I.svg";
import alphabetJ from "./images/J.svg";
import alphabetK from "./images/K.svg";
import alphabetL from "./images/L.svg";
import alphabetM from "./images/M.svg";
import alphabetN from "./images/N.svg";
import alphabetO from "./images/O.svg";
import alphabetP from "./images/P.svg";
import alphabetQ from "./images/Q.svg";
import alphabetR from "./images/R.svg";
import alphabetS from "./images/S.svg";
import alphabetT from "./images/T.svg";
import alphabetU from "./images/U.svg";
import alphabetV from "./images/V.svg";
import alphabetW from "./images/W.svg";
import alphabetX from "./images/X.svg";
import alphabetY from "./images/Y.svg";
import alphabetZ from "./images/Z.svg";
import defaultIcon from "./images/default.svg";

export const AlphabetImages: { [key: string]: string } = {
	A: alphabetA,
	B: alphabetB,
	C: alphabetC,
	D: alphabetD,
	E: alphabetE,
	F: alphabetF,
	G: alphabetG,
	H: alphabetH,
	I: alphabetI,
	J: alphabetJ,
	K: alphabetK,
	L: alphabetL,
	M: alphabetM,
	N: alphabetN,
	O: alphabetO,
	P: alphabetP,
	Q: alphabetQ,
	R: alphabetR,
	S: alphabetS,
	T: alphabetT,
	U: alphabetU,
	V: alphabetV,
	W: alphabetW,
	X: alphabetX,
	Y: alphabetY,
	Z: alphabetZ,
	default: defaultIcon,
};

export function getAlphabetImageSrc(name?: string, defaultLetter = "A") {
	if (!name) {
		return AlphabetImages[defaultLetter];
	}

	const convertedName = name
		?.replace(/[^a-z]/gi, "")
		.charAt(0)
		.toUpperCase();

	if (convertedName in AlphabetImages) {
		return AlphabetImages[convertedName];
	}

	return AlphabetImages["default"];
}
